import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { lookFor } from '../data/framework';
export function LookFor() {
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-222" data-mp="2vtabtsykhnx1">
      <div className="mx-auto max-w-5xl" data-id="element-223" data-mp="2vsihelgphw8c">
        <SectionHeading eyebrow="What Periodontal Professionals Should Look For" title="A Practical Reference Should Be Useful Beyond the First Read" intro="I designed Perio Blueprint™ to be a resource you can revisit, not simply a document you read once and forget. As you evaluate the product, look for three things." data-id="element-224" data-mp="2quh28bmeih25" />

        <ol className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-225" data-mp="2d43p7uunkc5y">
          {lookFor.map((l, i) => <li key={l.title} className="border-t-2 border-brand pt-5" data-id="element-226" data-mp="282egiluwkal1" data-mpi={i}>
              <span className="font-serif text-5xl font-black leading-none text-brand" data-id="element-227" data-mp="3ogwe8xw26mib">{i + 1}</span>
              <h3 className="mt-3 text-xl font-extrabold text-ink" data-id="element-228" data-mp="3ji32b9wf73k9">{l.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-229" data-mp="3mwqf643mmc0l">{l.text}</p>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-230" data-mp="3rtqocnvrvuvx">
          <p data-id="element-231" data-mp="picxao06l8s">Those are the principles I used to develop Perio Blueprint™.</p>
          <p className="font-serif text-xl font-bold text-brand-dark sm:text-2xl" data-id="element-232" data-mp="5mikxr4exy2j">
            I believe an educational reference should earn your confidence through the quality of its content, the clarity
            of its organization, and its usefulness over time.
          </p>
        </div>

        <div className="mt-10" data-id="element-233" data-mp="3e2lq9q81zanp">
          <CTAButton label="I Want a Reference I Can Reuse" data-id="element-234" data-mp="3e1k4aqpi13r7" />
        </div>
      </div>
    </section>;
}